import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type GetCollectionQuery } from 'domains/collections/api'

interface Props {
  subject: GetCollectionQuery['collection']['subjects'][0]
}

export const collectionsViewRuleIsSearchTerm = (
  rule: GetCollectionQuery['collection']['subjects'][0]
): boolean => rule.criteriaTerms.length > 0

export const CollectionsViewRuleSearchTerm: FunctionComponent<Props> = ({ subject }) => {
  const labelMessage = useDomainMessage('collectionsDomain.view.content.rule.searchTerm.label')
  return (
    <Text data-testid={`collections-view-rule-search-term-${subject.id}`} size="medium">
      {labelMessage}
      &rsquo;{subject.criteriaTerms.map(term => term)}&rsquo;
    </Text>
  )
}
